import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import ProfilePage from './account/ProfilePage';
import SecurityPage from './account/SecurityPage';
import BillingPage from './account/BillingPage';
import NotificationsPage from './account/NotificationsPage';
import './Account.css';

function Account() {
    useEffect( () => { console.log('Account component rendered');
		     }, []);

    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;

    // Determine which tab is active based on the current path
    const getActiveTab = () => {
	if (currentPath.includes('/security')) return 'security';
	if (currentPath.includes('/billing')) return 'billing';
	if (currentPath.includes('/notifications')) return 'notifications';
	return 'profile'; // Default tab
    };

    const handleTabClick = (tab) => {
    switch (tab) {
      case 'security':
        navigate('/account/security');
        break;
      case 'billing':
        navigate('/account/billing');
        break;
      case 'notifications':
        navigate('/account/notifications');
        break;
      default:
        navigate('/account');
    }
  };


    
  const [user, setUser] = useState({
    name: 'Jenna Muntz',
    email: 'jenna.muntz@herdinghelpers.com',
    phone: '(402) 123-4567',
    address: '123 Herding Lane, Pastureville',
    preferences: {
      notifications: true,
      newsletter: false,
      twoFactorAuth: true
    }
  });

  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({...user});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name.includes('.')) {
      // Handle nested properties (preferences)
      const [parent, child] = name.split('.');
      setFormData({
        ...formData,
        [parent]: {
          ...formData[parent],
          [child]: type === 'checkbox' ? checked : value
        }
      });
    } else {
      // Handle top-level properties
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

    // eslint-disable-next-line
  const handleSubmit = (e) => {
    e.preventDefault();
    setUser(formData);
    setIsEditing(false);
  }
    
  return (
    <div className="account-page">
      <h1>Account Settings</h1>

      <div className="account-container">
          <div className="account-sidebar">
          <ul>
            <li
              className={getActiveTab() === 'profile' ? 'active' : ''}
              onClick={() => handleTabClick('profile')}
            >
              Profile
            </li>
            <li
              className={getActiveTab() === 'security' ? 'active' : ''}
              onClick={() => handleTabClick('security')}
            >
              Security
            </li>
            <li
              className={getActiveTab() === 'billing' ? 'active' : ''}
              onClick={() => handleTabClick('billing')}
            >
              Billing
            </li>
            <li
              className={getActiveTab() === 'notifications' ? 'active' : ''}
              onClick={() => handleTabClick('notifications')}
            >
              Notifications
            </li>
          </ul>
        </div>

          <div className="account-content">
          <Routes>
            <Route path="/" element={<ProfilePage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

    
export default Account;
